export const fillWithZero = (stringValue: string, maxLength: number): string => {
  if (stringValue && stringValue.length < maxLength) {
    const fillZero = maxLength - stringValue.length;

    const arrayZero = Array(fillZero).fill(0);

    return `${arrayZero.join('')}${stringValue}`;
  }

  return stringValue;
};
